export type LearningType = 'CMP' | 'PRP' | 'PRP-FM';

/**
 * Represents the enrolment / registration status of a learner in the LMS.
 * Statut d'inscription d'un apprenant dans le LMS.
 */
export type LearnerStatus =
  | 'Pending'
  | 'notRegistered'
  | 'Registered'
  | 'Submitted'
  | 'Withdrew'
  | 'Exempt';

export * from './mmi-case-type.enum';

export interface LearningCreate {
    capacity: number;
    activate: boolean;
    foundationStartDate: Date;
    foundationEndDate: Date;
    advancedStartDate: Date;
    advancedEndDate: Date;
}

export interface Learning {
    id: string;
    programName: string;
    registrations: number;
    foundationStartDate: string;
    foundationEndDate: string;
    advancedStartDate: string;
    advancedEndDate: string;
    capacity: number;
    activate: boolean;
    status: string;
    type: string;
    usersIds: string[];
}


export enum LoadingState {
    loadingList = "loadingList",
    loadingAddUpdate = "loadingAddUpdate",
    loadingDelete = "loadingDelete",
    notLoading = "notLoading",
}